export const MAIN_URL = "https://api.falconoasis.io/FALCON/FALCON/API/api.php";
export const UPLOAD_API_LINK =
  "https://api.falconoasis.io/FALCON/FALCON/API/upload.php";
